import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

/**
 * Generates an Excel file with multiple sheets.
 * @param {Object[]} sheetsData - Array of objects containing sheet data.
 * @param {string} fileName - The name of the exported Excel file.
 */
const generateMultiSheetXlsx = (sheetsData, fileName = "Multiple_Sheets.xlsx") => {
  const wb = XLSX.utils.book_new();

  sheetsData.forEach(({ sheetName, data, columns }) => {
    const ws = XLSX.utils.json_to_sheet(data, { header: columns });

    // Append the sheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
  });

  // Generate the Excel file
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

  // Create and save the file
  const finalData = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(finalData, fileName);
};

export default generateMultiSheetXlsx;
